// Старые записи хранят описание действия и пояснение человека одной строкой.
// Разбираем только известные форматы; неизвестный текст не выдаём за цитату.
export function fulfillmentSpeech(action, description, executorName) {
    const prefixes = {
        fulfillment_dispute: /^При приёмке возникла проблема:\s*/,
        fulfillment_shipping: /^Отгрузка сохранена\.\s*/,
        fulfillment_acceptance: /^Приёмка сохранена\.\s*/,
        fulfillment_in_transit: /^Ждём доставку до \S+\.\s*/,
        fulfillment_review_continue: /^Работу по заявке продолжат\.(?: Исполнитель: #\d+\. Новый срок: \d{2}\.\d{2}\.\d{4} \d{2}:\d{2}\.)?(?: Вопрос по приёмке остаётся открытым\.)?\s*/,
        fulfillment_review_stop: /^(?:Работу закончили\. Можно принимать результат|Заявку закрыли|Часть работы закончена\. Другие исполнители ещё работают)\.(?: Вопрос по приёмке остаётся открытым\.)?\s*/,
        fulfillment_review_resolve_acceptance: /^(?:Заявку закрыли|Заявка закрыта без подтверждения приёмки)\.\s*/,
        fulfillment_close_without_acceptance: /^Заявка закрыта без подтверждения приёмки\.\s*/,
        fulfillment_close_without_shipment: /^Заявка закрыта без поставки\. Количества сохранены\.\s*/,
        fulfillment_close_legacy_without_acceptance: /^Старая заявка закрыта без подтверждения приёмки\. Количества сохранены\.\s*/,
        fulfillment_explain_delivery: /^Исполнитель передал пояснение о завершении своей работы\. Спор остаётся открытым\.\s*/
    };
    const prefix = prefixes[action];
    const text = String(description || '').replace(/\r\n?/g, '\n');
    const match = prefix && text.match(prefix);
    if (!match) return null;

    const blocks = [];
    const add = (kind, value) => {
        if (value.trim()) blocks.push({kind, text: value.trim()});
    };
    const systemText = action === 'fulfillment_review_continue'
        ? match[0].replace(/Исполнитель: #\d+\./, () => `Исполнитель: ${executorName || 'имя недоступно'}.`)
        : match[0];
    add('system', action === 'fulfillment_dispute' ? 'При приёмке сообщили о проблеме.' : systemText);
    const rest = text.slice(match[0].length);
    // These events append only the author's explanation, never generated item rows.
    if (!['fulfillment_shipping', 'fulfillment_acceptance', 'fulfillment_dispute', 'fulfillment_in_transit'].includes(action)) {
        add('human', rest);
        return blocks;
    }
    // Строки количеств генерирует сервер. Переносы внутри пояснения сохраняем.
    const itemStart = /(?:^|\n)(?=[^\n]+ \(#\d+\): (?:заказано|отгружено) )/;
    const start = rest.search(itemStart);
    add('human', start < 0 ? rest : rest.slice(0, start));
    const lines = start < 0 ? [] : rest.slice(start).trimStart().split(/\n(?=[^\n]+ \(#\d+\): (?:заказано|отгружено) )/);
    lines.forEach(line => {
        const reasonIndex = line.indexOf(' Причина: ');
        if (reasonIndex < 0) add('system', line);
        else {
            add('system', line.slice(0, reasonIndex));
            add('human', line.slice(reasonIndex + ' Причина: '.length));
        }
    });
    return blocks;
}
